<template>
    <div class="BarChartCrosswise">
        <p v-if="hasLine" class="homeComTitle hasLine">
            <span class="titleLine"></span>
            <span class="flex_1"> {{ title }}</span>
        </p>
        <p v-if="!onlyChart && !hasLine" class="homeComTitle" :class="[ imgClass ]">
            <span class="flex_1"> {{ title }}</span>
            <!--            <span class="fs14 co_666 font_n" @click="$emit('checkDetail')">查看详情</span>-->
        </p>
        <section>
            <p v-if="!onlyChart" class="content fs14" v-html="setContent || content"></p>
            <p  class="chartTitle fs14 font_b co_666">
                <span v-show="hasChartTitleLine" class="titleLine"></span>
                <span class="flex_1" :class="hasChartTitleLine ? 'co_333' : ''"> {{ chartTitle }}</span>
            </p>
            <section class="flex_box mainBox">
                <div class="leftContent">
                    <div class="flex_box">
                        <p class="first fs11 text_r co_666">{{ firstTitle }}</p>
                        <p class="flex_1 fs11 text_c co_666">{{ unitEntityStr }}</p>
                    </div>
                    <div class="flex_box line34 co_666" v-for="item in riskArr.slice(0,tagNum)" :key="item.category">
                        <p class="first fs13 text_r line-clamp_1">{{ item.category }}</p>
                        <p class="flex_1 fs13 text_c">{{ item.count }}</p>
                    </div>
                </div>
                <div class="chartBox flex_1">
                    <p v-bind:class="'line_height_'+ count" class="lineBox"><span>0</span></p>
                    <p v-bind:class="'line_height_'+ count" class="lineBox"><span>50</span></p>
                    <p v-bind:class="'line_height_'+ count" class="lineBox"><span>100</span></p>
                    <p class="fs11 text_c co_666">{{headPerStr}}</p>
                    <div class="flex_box line34 co_666 barBg" v-for="item in riskArr.slice(0,tagNum)" :key="item.category">
                        <p :style="{ width: `${ item.per }%`  }"></p>
                        <span class="co_main fs13 ml2">{{ item.per ? item.per : "" }}</span>
                    </div>
                </div>
            </section>

            <div class="mt20 text_l co_a4a4 fs10_center" v-html="riskDesc"></div>
            <!--        <div class="checkMore text_c co_666" @click="checkMore">查看更多</div>-->
        </section>
    </div>
</template>

<script>
import _com from "@/util/common";
import _co from "@/util/const";

const _ = require('loadsh');

export default {
    name: "BarChartCrosswise",
    props: {
        title: {
            type: String,
            default: '传播影响力分布'
        },
        chartTitle: {
            type: String,
            default: '监管关注的十类风险'
        },
        firstTitle: {
            type: String,
            default: '核心风险'
        },
        imgClass: {
            type: String,
            default: 'textIcon'
        },
        tagNum: {
            type: Number,
            default: 5
        },
        renderData: Array,
        yesterdayData: Array,
        entityType: String,
        isEffect: Boolean,
        onlyChart: Boolean,
        setContent: String,
        hasLine: Boolean,
        hasChartTitleLine: Boolean,// chart title 标题前是否有竖线
        riskType: { //风险类型：内容风险 ｜ 银保风险
            type: String,
            default: 'contentRisk'
        },
    },
    data() {
        return {
            headPerStr:"",
            unitEntityStr:"",
            heads: [],
            content: '',
            riskDesc: _co.contentRiskDesc,
            chart: null,
            riskArr: [],
            count: 0,
            total: 0
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.renderFunc()
        })
    },
    methods: {
        checkMore() {
            console.log('checkMore');
        },
        renderFunc() {
            // this.unitEntityStr = this.entityType == "industry" ? "事件数(件)" : "报道量(篇)";
            this.unitEntityStr = "事件数(件)" ;
            this.headPerStr = `在所有${ this.firstTitle == "核心风险" ? "风险" : "内容风险点"}中占比(%)`;
            //!!导出ppt使用
            this.heads = [this.firstTitle, this.unitEntityStr];

            //1.监管风险正常还是得正常要体现出来，即数据为0也正常展示
            //2.内容风险没有标签的话，默认展示5个
            let items = this.renderData || [];
            let defaultItems = _.cloneDeep(_co.defalutRiskMap[this.riskType]);
            if(this.riskType == "yinbaoRisk"){//TODO 如果其他风险为0时， 需将【其他风险】放到数组尾部
                this.riskDesc = _co.yinbaoRiskDesc;
                let cloneItems = _.remove(items, item =>{
                    return item.category =="其他风险" && item.count == 0;
                });
                if(cloneItems.length){
                    items = items.concat({category:"其他风险", count:0})
                }
            }

            if(this.riskType == "contentRisk" && !items.length){
                items = defaultItems;
            }

            this.total = _.sumBy(items, "count");
            this.riskArr = _.map(items, r => {
                return {
                    category: r.category,
                    count: r.count,
                    per: _com.formatPercentAndTofixed_V2(r.count, this.total)
                }
            })
            this.riskArr = this.riskArr.slice(0,this.tagNum)
            this.count = this.riskArr.length

        }
    }
}
</script>

<style lang="scss" scoped>
.BarChartCrosswise {
    font-family: PingFangSC-Regular;
    padding: 5px 0 10px 0;
    background-color: #FFFFFF;

    .homeComTitle {
        position: relative;
        margin: 0 16px;

        .co_666 {
            position: absolute;
            right: 0;
        }
    }

    .content {
        margin: 12px 16px 0;
    }

    .leftContent {
        width: 175px;

        > div:first-child {
            margin-bottom: 10px;
        }



        .first {
            width: 106px;
        }
    }

    .mainBox {
        padding-right: 20px;
    }
    .line34 {
        line-height: 34px;
    }
    .chartBox {
        position: relative;
        height: auto;

        .lineBox {
            width: 0;
            border-right: 1px dashed #C9C9CA;
            position: absolute;
            top: 24px;

            span {
                display: inline-block;
                width: 20px;
                text-align: center;
                font-size: 11px;
                position: absolute;
                bottom: -22px;
                right: -10px;
            }

            &:nth-child(1) {
                left: 0;
            }

            &:nth-child(2) {
                left: 50%;
            }

            &:nth-child(3) {
                left: 100%;
            }
        }

        .fs11 {
            margin-bottom: 10px;
        }

        .barBg {
            align-items: center;
            p{
                height: 15.5px;
                background-color: #376CCF;
                border-radius: 8px;
                position: relative;
                span {
                    position: absolute;
                    right: -18px;
                    line-height: 16px;
                    font-size: 12px;
                }
            }

        }
    }

    .checkMore {
        margin-top: 24px;
    }
}
</style>